import React from "react";
import { Badge } from "reactstrap";

import { ClientTagChip } from "../../types/clientTag";

type ClientTagChipsProps = {
  tags?: ClientTagChip[] | null;
  maxVisible?: number;
  className?: string;
  size?: "sm" | "md";
};

const contrastText = (hex: string | null | undefined): string => {
  if (!hex || !/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return "";
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#212529" : "#ffffff";
};

const ClientTagChips = ({
  tags,
  maxVisible = 4,
  className = "",
  size = "sm",
}: ClientTagChipsProps) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  const visible = tags.slice(0, maxVisible);
  const remaining = tags.length - visible.length;

  return (
    <span className={`d-inline-flex flex-wrap align-items-center gap-1 ${className}`.trim()}>
      {visible.map((tag) => {
        const style =
          tag.color && /^#[0-9A-Fa-f]{6}$/.test(tag.color)
            ? {
                backgroundColor: tag.color,
                color: contrastText(tag.color),
                border: "none",
              }
            : undefined;

        return (
          <Badge
            key={tag.id}
            color={style ? undefined : "soft-secondary"}
            className={`fw-normal ${size === "sm" ? "fs-11" : ""}`.trim()}
            style={style}
            title={tag.is_active ? tag.name : `${tag.name} (inativa)`}
          >
            {tag.name}
          </Badge>
        );
      })}
      {remaining > 0 ? (
        <Badge color="soft-secondary" className="fw-normal fs-11">
          +{remaining}
        </Badge>
      ) : null}
    </span>
  );
};

export default ClientTagChips;
